import { axiosInstance as request } from '@api/rest.service'

const api = entity => `/meta-data-columns/${entity}`

export const GET_METADATA_COLUMNS_FOR_ENTITY = entity => request.get(api(entity))
